import type { Program, Theme } from 'planby';
import { today, tomorrow, since, till } from '../constants';

// Temporrary hack to set always a current day
export const getModifiedPrograms = (programs: Program[]) =>
    programs.map((program) => {
        const programSince = new Date(program.since);
        const programTill = new Date(program.till);

        // Determine base date (today or tomorrow)
        const baseDate = program.isTomorrow ? tomorrow : today;

        // Preserve original time but update only the date
        const newSince = new Date(
            baseDate.getFullYear(),
            baseDate.getMonth(),
            baseDate.getDate(),
            programSince.getHours(),
            programSince.getMinutes(),
            programSince.getSeconds()
        );

        const newTill = new Date(
            baseDate.getFullYear(),
            baseDate.getMonth(),
            baseDate.getDate(),
            programTill.getHours(),
            programTill.getMinutes(),
            programTill.getSeconds()
        );

        return {
            ...program,
            since: newSince.toISOString(),
            till: newTill.toISOString(),
        };
    });

export const getModifiedChannels = (channels) => {
    return channels.map((channel) => ({
        channelUuid: channel.uuid,
        id: channel.uuid,
        title: '<needed-to-satisfy-typescript>',
        description: '<needed-to-satisfy-typescript>',
        image: '<needed-to-satisfy-typescript>',
        since,
        till,
    }));
};

// custom theme
export const customTheme: Theme = {
    primary: {
        600: 'var(--white-10)',
        900: 'var(--primary-colors-background)',
    },
    grey: { 300: '#d1d1d1' },
    white: '#fff',
    green: {
        300: 'var(--primary-colors-orange)',
    },
    loader: {
        teal: '#5DDADB',
        purple: '#3437A2',
        pink: '#F78EB6',
        bg: '#171923db',
    },
    scrollbar: {
        border: 'var(--primary-colors-background)',
        thumb: {
            bg: 'var(--primary-colors-background)',
        },
    },
    gradient: {
        blue: {
            300: '#fff',
            600: '#fff',
            900: '#fff',
        },
    },
    text: {
        grey: {
            300: '#a0aec0',
            500: '#718096',
        },
    },
    timeline: {
        divider: {
            bg: '#718096',
        },
    },
};

export const getChannelPreviousDate = (channelId: string, selectedDate: string, previousDates: any) => {
    return previousDates.find((item) => item.channelId === channelId)?.date || selectedDate;
};

export const getChannelFutureDate = (channelId: string, selectedDate: string, futureDates: any) => {
    return futureDates.find((item) => item.channelId === channelId)?.date || selectedDate;
};
